import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Grid, Box, Table, TableBody, TableCell, TableRow, Paper } from '@mui/material';
import apiRequest from '../../functions/api';
class CachedSearch {
  constructor(resultsHandler, setRedirect) {
    this.resultsHandler = resultsHandler;
    this.setRedirect = setRedirect;
    this.query = "";
    this.queryCount = 0;
    this.cache = {};
    this.cacheHits = 0;
    this.cacheHitsHistory = [];
  }
  resultCb = (response) => {
    if (response.status === 200) {
      this.cache[response.data.filter] = (response.data.counter === "0") ? [] : response.data.results;
      this.queryCount = this.queryCount + 1;
      //console.log("query added to cache:", response.data.filter);
      this.resultsHandler(this.cache[response.data.filter]);
    } else {
      if (response) {
        console.log(response.data.message)
      } else {
        console.log('Keine Internetverbindung');
      }
    }
  }
  changeQuery( payload, headers, query) {
    if (query.length < 2) {
      // noop
      this.resultsHandler([]);
      return;
    }
    if (this.cache[query]) {
      this.cacheHits = this.cacheHits + 1;
      this.queryCount = this.queryCount + 1;
      this.cacheHitsHistory.concat(query);
      //console.log("query retrieved from cache:", query);
      this.resultsHandler(this.cache[query]);
    } else {
      apiRequest('POST', 'daten', payload, headers, this.resultCb);
    }
  }
}
function AddressSearch(props) {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const { client, accessToken } = props;
  const navigate = useNavigate();
  const setRedirect = (path) => {
    navigate(path);
  }
  const handleResults = (results) => {
    setResults(results);
  }
  var CachedSearch1 = new CachedSearch(handleResults, setRedirect);
  const handleQueryChange = (query) => {
    setQuery(query);
    const payload={
        "mandant": client, // this.props.client,
        "program": "ADRWEB",
        "statement": "ADRESSEN_LESEN",
        "filter": query,
        "max-entries": 10
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
    }
    CachedSearch1.changeQuery(payload, headers, query);
  }
  const displayResult = results.map((dataObject) => {
    const key = dataObject.key;
    const surname = dataObject.surname;
    const name = dataObject.name;
    const company = dataObject.company.name;
    return(
      <TableRow key={dataObject.key} onClick={() => navigate('/ADRWEB/'+key)}>
        <TableCell>{surname+' '+name}</TableCell>
        <TableCell>{company}</TableCell>
      </TableRow>
    );
  });
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <Box pt={2} pl={2} pr={2}>
          <TextField
            fullWidth
            label={t("Suche")}
            id="filter"
            variant="outlined"
            value={query}
            inputProps={{
              autocapitalize: 'off',
              autocorrect: 'off',
              spellcheck: 'false',
              autocomplete: 'off'
            }}
            onChange={({ target: { value } }) => handleQueryChange(value)}
          />
        </Box>
        <Box p={2}>
          {results.length !== 0 &&
            <Paper>
            <Table>
              <TableBody>
                {displayResult}
              </TableBody>
            </Table>
          </Paper>
          }
        </Box>
      </Grid>
    </Grid>
  )
}

export default AddressSearch;
